(function() {
  'use strict';

  var navContainer = document.querySelector('.global-navigation');
  if (!navContainer) return;

  var navButtonsWrapper = navContainer.querySelector('.global-navigation__buttons');
  var navButtons = navContainer.querySelectorAll('.global-navigation__button');
  var sections = [];
  var isInitialized = false;
  var originalOffsetTop = 0;
  var placeholderEl = null;

  function init() {
    if (isInitialized) return;
    isInitialized = true;

    // Store original position
    originalOffsetTop = navContainer.offsetTop;

    // Create placeholder to prevent content jump when nav becomes fixed
    placeholderEl = document.createElement('div');
    placeholderEl.className = 'global-navigation-placeholder';
    placeholderEl.style.display = 'none';
    placeholderEl.style.height = navContainer.offsetHeight + 'px';
    navContainer.parentNode.insertBefore(placeholderEl, navContainer.nextSibling);

    // Collect all target sections
    navButtons.forEach(function(button) {
      var targetId = button.getAttribute('data-target');
      var targetElement = document.getElementById(targetId);
      if (targetElement) {
        sections.push({ id: targetId, element: targetElement, button: button });
      }
    });

    // Click handler for smooth scroll
    navButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = this.getAttribute('data-target');
        var targetElement = document.getElementById(targetId);

        if (targetElement) {
          var navHeight = navContainer.offsetHeight;
          var headerVisible = isHeaderVisible();
          var headerHeight = headerVisible ? getHeaderHeight() : 0;
          var totalOffset = headerHeight + navHeight + 20;
          var elementPosition = targetElement.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.pageYOffset - totalOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          // Trigger active state update shortly after scroll starts
          setTimeout(function() {
            updateActiveSection();
          }, 100);
        }
      });
    });

    // Start scroll listener
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateStickyState();
          updateActiveSection();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Handle resize
    window.addEventListener('resize', function() {
      if (!navContainer.classList.contains('is-fixed')) {
        originalOffsetTop = navContainer.offsetTop;
      }
      placeholderEl.style.height = navContainer.offsetHeight + 'px';
    });

    // Initial update
    updateStickyState();
    updateActiveSection();
  }

  function getHeaderHeight() {
    var header = document.querySelector('#SiteHeader');
    if (header) {
      return header.offsetHeight;
    }
    return 0;
  }

  function isHeaderVisible() {
    var header = document.querySelector('#SiteHeader');
    if (!header) return false;
    return !header.classList.contains('header-hidden');
  }

  function updateStickyState() {
    var header = document.querySelector('#SiteHeader');
    var headerHeight = header ? header.offsetHeight : 0;
    var isHeaderHidden = header ? header.classList.contains('header-hidden') : true;
    var scrollY = window.pageYOffset;

    // Determine if nav should be fixed
    var triggerPoint = originalOffsetTop - headerHeight;
    var shouldBeFixed = scrollY > triggerPoint;

    if (shouldBeFixed && !navContainer.classList.contains('is-fixed')) {
      navContainer.classList.add('is-fixed');
      placeholderEl.style.display = 'block';
    } else if (!shouldBeFixed && navContainer.classList.contains('is-fixed')) {
      navContainer.classList.remove('is-fixed');
      placeholderEl.style.display = 'none';
    }

    // Update top position based on header visibility
    if (navContainer.classList.contains('is-fixed')) {
      if (isHeaderHidden) {
        navContainer.style.top = '0px';
      } else {
        navContainer.style.top = headerHeight + 'px';
      }
    } else {
      navContainer.style.top = '';
    }
  }

  function updateActiveSection() {
    if (sections.length === 0) return;

    var navHeight = navContainer.offsetHeight;
    var headerVisible = isHeaderVisible();
    var headerHeight = headerVisible ? getHeaderHeight() : 0;
    var scrollPosition = window.pageYOffset + headerHeight + navHeight + 50;

    var activeSection = null;

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var sectionTop = section.element.offsetTop;
      var nextSection = sections[i + 1];
      var sectionBottom = nextSection ? nextSection.element.offsetTop : document.body.scrollHeight;

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        activeSection = section;
        break;
      }
    }

    // Update active states
    navButtons.forEach(function(btn) {
      btn.classList.remove('is-active');
    });

    if (activeSection) {
      activeSection.button.classList.add('is-active');

      // Get button boundaries relative to the scrollable container
      var button = activeSection.button;
      var buttonRect = button.getBoundingClientRect();
      var containerRect = navButtonsWrapper.getBoundingClientRect();

      // Check if button is fully visible within the container
      var isVisibleLeft = buttonRect.left >= containerRect.left;
      var isVisibleRight = buttonRect.right <= containerRect.right;

      if (!isVisibleLeft || !isVisibleRight) {
        // Use scrollIntoView for reliable cross-browser scrolling
        button.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    } else {
      // No active section (user scrolled above all sections) - scroll nav back to start
      if (navButtonsWrapper.scrollLeft > 0) {
        navButtonsWrapper.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
